import { render, staticRenderFns } from "./Organiser.vue?vue&type=template&id=1487325a&lang=html"
import script from "./Organiser.vue?vue&type=script&lang=js"
export * from "./Organiser.vue?vue&type=script&lang=js"
import style0 from "./Organiser.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports